import {Injectable} from "@angular/core";
import {AuthEmailResponse} from "../model/sso/AuthEmailResponse";


@Injectable()
export class SessionManager {

  auth(item: AuthEmailResponse) {
    console.log(item)
    localStorage.setItem("token", item.token);
    localStorage.setItem("email", item.email);
    localStorage.setItem("id", item.id);
    localStorage.setItem("name", item.name);
    localStorage.setItem("phone", item.phone);
    localStorage.setItem("roles", JSON.stringify(item.roles));
    localStorage.setItem("status", item.status);
    localStorage.setItem("refreshToken", item.refreshToken);
    localStorage.setItem("lastRefresh", new Date().getMonth().toString());
  }

  token() {
    return localStorage.getItem("token")
  }

  lastRefresh() {
    return localStorage.getItem("lastRefresh")
  }


  refreshToken() {
    return localStorage.getItem("refreshToken")
  }

  phone() {
    return localStorage.getItem("phone")
  }

  email() {
    return localStorage.getItem("email")
  }

  id() {
    return localStorage.getItem("id")
  }

  name() {
    return localStorage.getItem("name")
  }

  status() {
    return localStorage.getItem("status")
  }

  active() {
    return this.status() == 'ACTIVE'
  }

  roles() {
    return JSON.parse(localStorage.getItem("roles") || "") as [string]
  }

  isSuperAdmin() {
    return this.roles().includes("SUPER_ADMIN")
  }

  isAdmin() {
    return this.roles().includes("ADMIN")
  }

  isManager() {
    return this.roles().includes("MANAGER")
  }

  isVip() {
    console.log("TEST" + this.roles())
    return this.roles().includes("VIP")
  }

  isAuth() {
    return this.token() != null && this.token() != ''
  }


  clear() {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("id");
    localStorage.removeItem("name");
    localStorage.removeItem("phone");
    localStorage.removeItem("roles");
    localStorage.removeItem("status");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("lastRefresh");
  }

  setTokens(token: string, refreshToken: string) {
    localStorage.setItem("token", token);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("lastRefresh", new Date().getMonth().toString());
  }
}
